import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiRadio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React from 'react';

import useStyles from './styles';

export type RadioProps = {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  label?: string;
  labelComponent?: React.ReactNode;
  labelPlacement?: 'bottom' | 'top' | 'end' | 'start';
  value?: string;
  checked?: boolean;
  onChange?: () => void;
};

export function Radio({
  value,
  label,
  disabled,
  labelComponent,
  labelPlacement = 'end',
  className,
  error,
  checked,
  onChange,
}: RadioProps): JSX.Element {
  const classes = useStyles();

  const radio = (
    <MuiRadio
      checked={checked}
      checkedIcon={<span className={classNames(classes.icon, classes.checkedIcon)} />}
      className={classes.root}
      color="primary"
      disabled={disabled}
      disableRipple
      icon={<span className={classNames(classes.icon, { error })} />}
      onChange={onChange}
    />
  );

  return (
    <FormControlLabel
      classes={{ label: classes.formControlLabel, root: classes.formControl }}
      className={className}
      color="default"
      control={radio}
      label={
        labelComponent ?? (
          <Typography color="textPrimary" variant="body2">
            {label}
          </Typography>
        )
      }
      labelPlacement={labelPlacement}
      value={value}
    />
  );
}
